<template>
  <main id="app">
	 <div>
		<div class="bg-light">
			<div class="container">
				<div class="row mb-2 align-items-center py-2">
					<div class="col-7">
						<div class="row">
							<div class="col-12 col-md-6 col-lg-4">
								<div v-if="currentPage != 'error'">
									<button type="button" class="btn btn-toggle measurement" @click="updateUnit(unit)" :class="{ active: unit == 'us' }">
										<div class="handle"></div>
									</button>
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-4">
								<button v-if="currentPage == 'home' || currentPage == 'results' || currentPage == 'charts'" type="button" class="btn btn-toggle fuelsrc" @click="oem = !oem" :class="{ active: oem }">
									<div class="handle"></div>
								</button>
							</div>
						</div>
					</div>
					<div class="col-5 text-right">
						<a v-if="currentPage == 'results'" class="btn btn-primary text-white" v-clipboard:copy="copyText" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">Copy URL</a>

						<a v-if="currentPage == 'charts'" :class="{ 'is-disabled': !urlValid }" class="btn btn-primary text-white"  v-clipboard:copy="chartsUrl" v-clipboard:success="copyUrlSuccess" v-clipboard:error="onCopyError">Generate url</a>

						<a v-if="currentPage == 'home'" class="btn btn-primary text-white" @click="compare">Compare &rarr; </a>
						<a v-if="currentPage == 'error'" class="btn btn-primary text-white" href="/">Select Bikes &rarr; </a>
					</div>
				</div>
			</div>
		</div>
		<loading :active.sync="isLoading" :is-full-page="fullPage">
		</loading>
		<div class="container mx-auto">
			<router-view></router-view>
		</div>
	</div>
  </main>
</template>


<script>

import Loading from "vue-loading-overlay";
import EventBus from './eventbus';

import "vue-loading-overlay/dist/vue-loading.css";

// Components
import Inputs from "./components/Inputs.vue";
import {mapGetters} from 'vuex';

export default {

	name: "ADVSpecs", 
	props: [],
	components: {
		Loading
	},

	data() {
		return {
			resultList: [],
			compareSelected: false,
			isLoading: true,
			fullPage: true,
			unit: 'metric',
			copyText: '',
			currentPage: '',
			oem: false,
			urlValid: false
		};
	},
	methods: {
		getData() {
			this.$http.get("/data/data.csv").then(response => {
				let lines = response.data.split("\n");
				let result = [];
				let headers = lines[0].split(",");
				let unit = lines[1].split(",");
				let removeHeader = lines.shift();
				let removeUnit = lines.shift();
				for (const items of lines) {
					//make sure there is content in the line
					if (items) {
						let obj = {};
						let currentline = items.trim().split(",");
						for (let j = 0; j < headers.length; j++) {
							// check the unit and see if it needs to be converted.
							// let value = this.calculations(unit[j].trim(), currentline[j]);
							let value = this.assignUnits(headers[j].trim().replace(/ /g, "_").replace(/\//g, "").toLowerCase(), currentline[j]);
							if(typeof value == 'string') {
								value = value.trim();
							}
							obj[headers[j].trim().replace(/ /g, "_").replace(/\//g, "").toLowerCase()] = (typeof value == 'string') ? value.trim() : value;
						}
						if (obj['publish'] == '1') {
							result.push(obj);
						}
					}
				}
				this.resultList = result;
				this.$store.dispatch('BikeDataStore/updateResultsList', result);
			}).then((this.isLoading = false)).catch(error => {
				console.log(error);
			});
		},
		assignUnits(name, value) {
			switch(name) {
				case 'engdisp':
				return this.calculations('cc', value);

				case 'engmaxpwr':
				return this.calculations('kW', value);

				case 'engmaxtrq':
				return this.calculations('nm', value);

				case 'bikewtdry':
				return this.calculations('kg', value);

				case 'bikewtlogic':
				return this.calculations('kg', value);

				case 'bikewtwet':
				return this.calculations('kg', value);

				case 'bikewtwetest':
				return this.calculations('kg', value);

				case 'bikefuelcap':
				return this.calculations('L', value);

				case 'wheeltravelfrt':
				return this.calculations('mm', value);

				case 'wheeltravelrear':
				return this.calculations('mm', value);

				case 'bikefueleconspec':
				return this.calculations('L/100km', value);

				case 'fuellydata':
				return this.calculations('L/100km', value);

				case 'fuellydataavg':
				return this.calculations('L/100km', value);

				case 'bikefueleconest':
				return this.calculations('L/100km', value);
				
				default:
				return value.length > 0 ? value : "0";
			}
		},
		calculations(unit, value) {
			switch (unit) {
			case "mm":
				return {
					metric: value.length > 0 ? parseFloat(value) : 0,
					us: value.length > 0 ? parseFloat(value) * 0.0393701 : 0,
					measurement: {us: 'in', metric: 'mm'}
				};
			case "kg":
				return {
					metric: value.length > 0 ? parseFloat(value) : 0,
					us: value.length > 0 ? parseFloat(value) * 2.20462262185 : 0,
					measurement: {us: 'lb', metric: 'kg'}
				};
			case "kW/kg":
				return {
					metric: value.length > 0 ? parseFloat(value) : 0,
					us: value.length > 0 ? parseFloat(value) * 0.608277163411382 : 0,
					measurement: {us: 'HP/lb', metric: 'kW/kg'}
				};
			case "cc":
				return {
					metric: value.length > 0 ? parseFloat(value) : 0,
					us: value.length > 0 ? parseFloat(value) * 0.0610237 : 0,
					measurement: {us: 'CI', metric: 'cc'}
				};
			case "kW":
				return {
					metric: value.length > 0 ? parseFloat(value) : 0,
					us: value.length > 0 ? parseFloat(value) * 1.3410220888 : 0,
					measurement: {us: 'HP', metric: 'kW'}
				};
			case "nm":
				return {
					metric: value.length > 0 ? parseFloat(value) : 0,
					us: value.length > 0 ? parseFloat(value) * 0.7375621 : 0,
					measurement: {us: 'ft/lb', metric: 'nm'}
				};
			case "L":
				return {
					metric: value.length > 0 ? parseFloat(value) : 0,
					us: value.length > 0 ? parseFloat(value) * 0.26417205236 : 0,
					measurement: {us: 'gal', metric: 'L'}
				};
			case "L/100km":
				return {
					metric: value.length > 0 ? parseFloat(value) : 0,
					us: value.length > 0 && parseFloat(value) > 0 ? 235.214583 / parseFloat(value) : 0,
					measurement: {us: 'mpg', metric: 'L/100km'}
				};
			default:
				return value.length > 0 ? value : "0";
			}
		},
		compare() {
			EventBus.$emit('compare');
		},
		updateUnit(value) {
			(value == 'metric') ? this.unit = 'us' : this.unit = 'metric';
			this.$store.dispatch('BikeDataStore/updateMeasurement', this.unit);
		},
		onCopySuccess: function (e) {
			alert(`Copied URL: ${this.copyText}`);
		},
		copyUrlSuccess: function() {
			alert(`Copied URL: ${this.copyText}`);
		},
		onCopyError: function (e) {
			alert('Failed to copy URL')
		}        
	},
	computed: {
		...mapGetters({
            chartsUrl: 'BikeDataStore/getChartsUrl',
    	}),
	},
	created() {
		this.copyText = `https://www.advspecs.com${this.$route.fullPath}`;
		this.currentPage = this.$route.name;
	},
	beforeMount() {
		this.getData();
	},
	
	mounted() {
		EventBus.$on('compareBikes', (data) => {

			let intersection = this.resultList.filter(item => data.bikes.includes(item.bikeid));
			
			let bikenames = intersection.map(item => `${item.make.trim().replace(/ /g, '-')}-${item.model.trim().replace(/ /g, '-')}`);
			let bikeids = intersection.map(item => `${item.bikeid}`);
			let unit = this.unit, 
				rider = data.inputs.rider[this.unit],
				gear = data.inputs.gear[this.unit],
				luggage = data.inputs.luggage[this.unit], 
				farkles = data.inputs.farkles[this.unit], 
				target = data.inputs.target[this.unit];       


			this.$router.push({
				name: 'results',
				params: {bikeids: bikeids.join('-'), bikenames: bikenames.join('-vs-') },
				query: { unit, rider, gear, luggage, farkles, target }
			})

		}),

		EventBus.$on('urlValid', () => {
			this.urlValid = true
		})
	},
	watch: {
		'$route' (to, from) {
			this.copyText = `https://www.advspecs.com${to.fullPath}`;
			this.currentPage = to.name;
			if(to.name == from.name) {
				this.unit = 'metric'
				window.history.go(-1);
			}
		},
		oem(value) {
			this.$store.dispatch('BikeDataStore/updateOem', this.oem)
		}
	}
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">

  $baseSize: 16px;
  $breakXS: 576px;
  $breakSM: 768px;
  $breakMD: 992px;
  $breakLG: 1200px;

  $factorXS: 0.8125;
  $factorSM: 0.875;
  $factorMD: 0.9375;
  $factorLG: 1;

  html {
    font-size: $baseSize * $factorXS;
    @media (min-width: $breakXS) and (max-width: $breakSM) {
      font-size: $baseSize * $factorXS;
    }
    @media (min-width: $breakSM) and (max-width: $breakMD) {
      font-size: $baseSize * $factorSM;
    }
    @media (min-width: $breakMD) and (max-width: $breakLG) {
      font-size: $baseSize * $factorMD;
    }
    @media (min-width: $breakLG) {
      font-size: $baseSize * $factorLG;
    }
    font-feature-settings: "liga" 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }


	.is-disabled {
		cursor: not-allowed;
	  	opacity: 0.5;
	}

	label, input:hover, .multiselect, .vue-select {
		cursor: pointer;
	}
	.figure {
		text-align: center;
	}
	img.figure-img.img-fluid.rounded {
		max-height: 100px;
	}

	// Mixin for Switch Colors
	@mixin toggle-color {
		color: #292b2c;
		background: #fff !important;
		border-color: rgba(#292b2c,0.333) !important;
		&:before,
		&:after {
			color: #292b2c;
		}
		&.active {
			background-color: #fff !important;
		}
	}

	// Mixin for Default Switch Styles
	@mixin toggle-mixin {
		margin: 0.25rem 4rem;
		padding: 0;
		position: relative;
		border: none;
		height: 1.5rem;
		width: 1.5rem * 2;
		border-radius: 1.5rem !important;
		&:focus,
		&.focus {
			&,
			&.active {
				outline: none;
			}
		}

		&:before,
		&:after {
			line-height: 1.5rem;
			width: 4rem;
			text-align: center;
			position: absolute;
			bottom: 0;
			transition: opacity .25s;
		}
		&:before {
			left: -4.5rem;
		}
		&:after {
			right: -4rem;
		}
		> .handle {
			position: absolute;
			top: (1.5rem * .25) / 2;
			left: (1.5rem * .25) / 2;
			width: 1.5rem * .75;
			height: 1.5rem * .75;
			border-radius: 1.5rem * .75;
			background: #007bff;
			transition: left .25s;
		}
		&:not(.active) {
			&:before {
				opacity: 1;
			}
			&:after {
				opacity: 0.33;
			}
		}
		&.active {
			transition: background-color .25s;
			> .handle {
				left: 1.5rem + ((1.5rem * .25) / 2);
				transition: left .25s;
			}
			&:before {
				opacity: .33;
			}
			&:after {
				opacity: 1;
			}
		} 
	}

	// Apply Mixin to different sizes & colors
	.btn-toggle {
	 	@include toggle-mixin;
	 	@include toggle-color;
	}

	.btn-toggle.measurement {
		&:before {
			content: 'Metric';
		}
		&:after {
			content: 'US';
		}
	}

	.btn-toggle.fuelsrc {
		&:before {
			content: 'Fuelly';
		}
		&:after {
			content: 'OEM';
		}
	}


</style>